<template>
    <div class="video-wrapper">
      <iframe
        :src="videoUrl"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
  </template>
  
  <script>
  export default {
    name: 'VimeoPlayer',
    props: {
      videoId: {
        type: String,
        required: true
      }
    },
    computed: {
      videoUrl() {
        return `https://player.vimeo.com/video/${this.videoId}?title=0&byline=0&portrait=0`
      }
    }
  }
  </script>
  
  <style scoped>
  .video-wrapper {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    margin-bottom: 2rem;
  }
  .video-wrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 12px;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15);
  }
  </style>